import type { ColumnDef } from "@tanstack/react-table"
import type { IReferralDetail } from "@apis/accounts/types"
import { CurrencyCell, DateCell, LinkCell } from "@utils/table/columnFactories"

export const referralColumns: ColumnDef<IReferralDetail>[] = [
  {
    accessorKey: "full_name",
    header: "Name",
    cell: ({ row }) => {
      const { account_id, membership_profile_id, full_name } = row.original
      if (account_id && membership_profile_id) {
        return (
          <LinkCell to={`/profiles/${membership_profile_id}/accounts/${account_id}`}>
            {full_name}
          </LinkCell>
        )
      }
      return full_name
    },
  },
  {
    accessorKey: "reward_amount",
    header: "Reward",
    cell: (props) => <CurrencyCell {...props} />,
  },
  {
    accessorKey: "accrued_dt",
    header: "Accrued",
    cell: (props) => <DateCell {...props} />,
  },
  {
    accessorKey: "vest_dt",
    header: "Vested",
    cell: (props) => <DateCell {...props} />,
  },
  {
    accessorKey: "fulfillment_channel",
    header: "Fulfilled",
  },
]
